import { render } from "./AppJS.vue?vue&type=template&id=3a1b80fe&scoped=true&ts=true"
import script from "./AppJS.vue?vue&type=script&lang=ts"
export * from "./AppJS.vue?vue&type=script&lang=ts"

import "./AppJS.vue?vue&type=style&index=0&id=3a1b80fe&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1b80fe"]])

export default __exports__